import {brands} from '@root/brands/brands';

export const brand = brands.chatiwi;
